/**
 * Store Registry — Single source of truth for all persisted Legend-State stores.
 *
 * Used by auth$.js logout() and pwaUtils.js for clearing persistence on logout/force-clean.
 * Lazy-loaded to avoid circular dependencies since some stores import auth$.
 *
 * All 14 persisted stores:
 *   - articles$, highlights$, comments$, lists$, aiConversations$, cards$, decks$
 *   - readingProgress$, articleLists$
 *   - ui$, readerFont$, audio$, ragConversations$
 *   - sharedListIds$ (from listMembers$)
 */

let _stores = null;

/**
 * Get all persisted stores for cleanup operations.
 * Lazy-loads stores on first call to avoid circular dependencies.
 *
 * @returns {Promise<Array>} Array of all persisted store observables
 */
export async function getAllPersistedStores() {
  if (!_stores) {
    const [
      { articles$ },
      { highlights$ },
      { comments$ },
      { lists$ },
      { aiConversations$ },
      { cards$ },
      { decks$ },
      { readingProgress$ },
      { articleLists$ },
      { ui$ },
      { readerFont$ },
      { audio$ },
      { ragConversations$ },
      { sharedListIds$ },
    ] = await Promise.all([
      import('./articles$'),
      import('./highlights$'),
      import('./comments$'),
      import('./lists$'),
      import('./aiConversations$'),
      import('./cards$'),
      import('./decks$'),
      import('./readingProgress$'),
      import('./articleLists$'),
      import('./ui$'),
      import('./readerFont$'),
      import('./audio$'),
      import('./ragConversations$'),
      import('./listMembers$'),
    ]);
    _stores = [
      articles$,
      highlights$,
      comments$,
      lists$,
      aiConversations$,
      cards$,
      decks$,
      readingProgress$,
      articleLists$,
      ui$,
      readerFont$,
      audio$,
      ragConversations$,
      sharedListIds$,
    ];
  }
  return _stores;
}
